export { DiversityLegend } from "./DiversityLegend";
